module.exports = __webpack_public_path__ + "img/add-icon-gray.22e6653f.svg";